export const ParsePeriodicalResult = (result, allSourceData = null) => {
  const state = {
    originalResults: null,
    groupedResults: null,
  }

  state.originalResults = JSON.parse(JSON.stringify(result));
  const tempRegionResults = JSON.parse(JSON.stringify(result));
  
  tempRegionResults.resultList = [];
  result.resultList.forEach(value => {
    const splitValue = value.resultName.split(':');
    if (splitValue.length > 0) {
      let findValue = tempRegionResults.resultList.find(x => x.resultName === splitValue[0]);
      if (findValue) {
        findValue.resultValue += value.resultValue;
      } else {
        value.resultName = splitValue[0];
        tempRegionResults.resultList.push(value);
      }
    }
  });
  tempRegionResults.resultList.sort((a, b) => b.resultValue - a.resultValue);
  state.groupedResults = tempRegionResults;

  if (allSourceData) {
    const sourceCodeList = allSourceData.map(item => item[0].split(':')[0]);
    sourceCodeList.forEach(value => {
      if (state.groupedResults.resultList.some(x => x.resultName === value) === false) {
        state.groupedResults.resultList.push({ resultName: value, resultValue: 0 });
      }
    });
  }
  
  return state;
}